import { combineReducers } from "redux";
import { jobReducer } from "./jobReducer";
import { jobOfficialReducer } from "./jobOfficial";

export const rootReducer = combineReducers({
  jobReducer: jobReducer,
  jobOfficialReducer: jobOfficialReducer,
});
